const langSet = {
  ja: 'japanese',
  en: 'english'
}

export default {
  current: (state) => {
    return langSet[state.current]
  }
}
